export function ScoreRing({ score, size = 120, label, testid }) {
  const pct = Math.max(0, Math.min(100, score || 0));
  const r = (size - 14) / 2;
  const circ = 2 * Math.PI * r;
  const color = pct >= 75 ? "#00E676" : pct >= 55 ? "#FF8800" : "#00B0FF";
  return (
    <div className="flex flex-col items-center" data-testid={testid}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="8" />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke={color}
            strokeWidth="8"
            strokeLinecap="round"
            strokeDasharray={circ}
            strokeDashoffset={circ - (circ * pct) / 100}
            style={{ transition: "stroke-dashoffset 1.2s cubic-bezier(0.22,1,0.36,1)", filter: `drop-shadow(0 0 8px ${color}66)` }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-display font-extrabold text-white" style={{ fontSize: size * 0.24 }}>{Math.round(pct)}</span>
          <span className="font-mono-tech text-[9px] tracking-widest text-slate-500">/ 100</span>
        </div>
      </div>
      {label && <p className="mt-2 font-mono-tech text-[10px] tracking-[0.25em] text-slate-400 uppercase text-center">{label}</p>}
    </div>
  );
}

export function ScoreBar({ label, value, testid }) {
  const pct = Math.max(0, Math.min(100, value || 0));
  return (
    <div data-testid={testid}>
      <div className="flex justify-between text-xs mb-1.5">
        <span className="text-slate-300">{label}</span>
        <span className="font-mono-tech text-slate-400">{Math.round(pct)}</span>
      </div>
      <div className="h-1.5 rounded-full bg-white/5 overflow-hidden">
        <div
          className="h-full rounded-full bg-gradient-to-r from-[#FF8800] to-[#00E676] transition-all duration-1000"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
